// extracted by mini-css-extract-plugin
export var textInput = "_kc-0";